export class InvalidUrlError extends Error {
  constructor(value: string) {
    super(`The value '${value}' is not a valid URL.`);
    this.name = "InvalidUrlError";
  }
}
